import { Row, Col, Input, Button, Form, Checkbox } from "antd";
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import ICON from "../../../../../assets/images/icon.png";
import { i18n } from '../../../../../i18n/i18n';
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../../i18n/i18n.constants";
import React from "react";

const FinishedPage = () => {
  const history = useHistory();

  const location: any = useLocation()
  const { t } = useTranslation(namespaces.pages.daolinv);
  useEffect(() => {
    window.onpopstate = e => {
      localStorage.clear();
      history.push('/contents/daolInv/consentRMF/loginMember')
    };
  });

  return (
    <>
      <div className="home-page">
        {console.log('State', location?.state)}
        <div className="container">
          <Row className="container-main row">
            <div className="content-left col-sm-5">
              <div className="info-left">
                <p className="text-center text-header">
                  {t("thanks_title")}
                </p>
                <p className="content-sub">
                  {t("thanks_text_descrip")}
                </p>
              </div>
            </div>
            <div className="content-right col-sm-7">
              <div className="login-form">
                <div className="text-center"><img className="finish-img" width="25%" src={ICON} alt="Daol" /></div>
                <p className="text-center text-header">
                  {t("thanks_descrip_header")}
                </p>
                {location?.state?.accept === "Y" ?
                  <p className="details-head">
                    <strong>{location?.state?.customerName}</strong> {t("consent_descrip_p1")} <strong>{location?.state?.taxId}</strong><br />
                    {t("thanks_descrip_p1")} <u>{t("thanks_descrip_p3")}</u> {t("thanks_descrip_p2")}
                  </p>
                  :
                  <p className="details-head">
                    <strong>{location?.state?.customerName}</strong> {t("consent_descrip_p1")} <strong>{location?.state?.taxId}</strong><br />
                    {t("thanks_descrip_p1")} <u>{t("thanks_descrip_p4")}</u> {t("thanks_descrip_p2")}
                  </p>
                }
              </div>
              <Row className="container-button finish-btn">
                <Col span={12}>
                  <Button className="back-page" href="https://www.daolinvestment.co.th/home">
                    {t("btn_backto_home")}
                  </Button>
                </Col>
              </Row>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};
export default FinishedPage;
